import ForeignHealthRaterPriceRequest from '@/modules/foreign-health/common/models/MID/requests/ForeignHealthRaterPriceRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type ForeignHealthRaterAnswers from '@/modules/foreign-health/rater/models/APP/ForeignHealthRaterAnswers'
import type ForeignHealthHiringAnswers from '@/modules/foreign-health/hiring/models/APP/ForeignHealthHiringAnswers'
import type Insured from '@/modules/common/common/models/APP/Insured'
import type AdditionalCoverage from '@/modules/common/common/models/APP/AdditionalCoverage'
import HealthRaterPriceInsuredToSave from '@/modules/health/common/models/MID/HealthRaterPriceInsuredToSave'
import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'

export default class GetPricingMapper {
  static toRequest(
    data: ForeignHealthRaterAnswers | ForeignHealthHiringAnswers,
    opts?: { isQuote?: boolean; mediator?: string } // opcional para tests; por defecto false
  ): ForeignHealthRaterPriceRequest & { isQuote: boolean } {
    const clientProduct: RaterPriceClientProduct[] = []
    if (data?.product) {
      clientProduct.push(
        new RaterPriceClientProduct({
          clientCode: data?.product.clientCode,
          productCode: data?.product.productCode
        })
      )
    }

    const req = new ForeignHealthRaterPriceRequest({
      businessLine: data.businessLine,
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.startDate),
      insuranceEndDate: data.endDate ? CommonMapper.toMiddlewareDate(data.endDate) : undefined,
      insuranceType: '10',
      quotationId: data.quotationId ?? undefined,
      quotationNumber: data.product?.quotationNumber ?? undefined,
      stayAbroadType: data.stayAbroadType,
      policyHolderPostal: data.holder.addressDetails.postalCode!,
      insureds: this.#mountInsureds(data.insureds, null),
      clientProduct: clientProduct.length ? clientProduct : null,
      mediator: opts?.mediator
    })
    ;(req as any).isQuote = opts?.isQuote ?? false
    return req as ForeignHealthRaterPriceRequest & { isQuote: boolean }
  }

  static #mountInsureds(insureds: Insured[], coverageKey: string | null) {
    return insureds.map((i, order) => {
      const coverages = this.#setCoverages(coverageKey, i.additionalCoverages)
      const optionalCoverage = coverages.length ? coverages : undefined

      return new HealthRaterPriceInsuredToSave({
        postalCode: i.addressDetails.postalCode!,
        birthDate: CommonMapper.toMiddlewareDate(i.userDetails.birthDate)!,
        riskNumber: String(order + 1),
        optionalCoverage
      })
    })
  }
  static #setCoverages(coverageKey: string | null, additionalCoverages: AdditionalCoverage[]) {
    if (coverageKey) {
      return [
        {
          coverageCode: coverageKey,
          sumInsured: null
        }
      ]
    }
    return additionalCoverages
      .filter((i) => i.checked)
      .map((c) => ({
        coverageCode: c.key,
        sumInsured: c.value ? String(c.value) : null
      }))
  }
}
